import type { PointerEvent, RefObject } from 'react'
import { Box, Group, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { TbGripHorizontal } from 'react-icons/tb'

const SplitDivider = ({
  dividerRef,
  onPointerDown,
}: {
  dividerRef: RefObject<HTMLDivElement>
  onPointerDown: (event: PointerEvent<HTMLDivElement>) => void
}) => {
  const { t } = useTranslation('documentation')
  return (
    <Box
      ref={dividerRef}
      role="separator"
      aria-orientation="horizontal"
      aria-label={t('dragToResize')}
      onPointerDown={onPointerDown}
      style={{
        flex: 'none',
        cursor: 'row-resize',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        userSelect: 'none',
        touchAction: 'none',
      }}
    >
      <Group
        gap={4}
        px={6}
        py={2}
        wrap="nowrap"
        style={{
          pointerEvents: 'none',
          borderRadius: 'var(--mantine-radius-xl)',
          border: '1px solid light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4))',
          background: 'light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6))',
        }}
      >
        <TbGripHorizontal size={14} color="var(--mantine-color-dimmed)" />
        <Text size="xs" c="dimmed" fw={600} lh={1}>
          {t('dragToResize')}
        </Text>
      </Group>
    </Box>
  )
}

export default SplitDivider
